<template>
  <div class="catalogue">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>参展</BreadcrumbItem>
          <BreadcrumbItem>采买咨询</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">采买咨询</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item"
             @click="hostExcelExportBack">
          <i class="icon iconfont icon-downLoad2"></i>
          <span>导出</span>
        </div>
      </div>
    </div>
    <div class="header-tabs">
      <Tabs :animated="false"
            @on-click="switchBrand"
            v-model="showTabs">
        <TabPane label="待接收"
                 name="0">
        </TabPane>

        <TabPane label="已接收"
                 name="1">
        </TabPane>

      </Tabs>
    </div>

    <div class="layout-content"
         style="background: transparent;">
      <div class="my-item">

        <template>
          <div v-if="list.length">
            <Row :gutter="30">
              <Col style="width:24%;float:left"
                   v-for="(item, index) in list"
                   :key="index">
              <div class="my-item-box">
                <!-- 头部 -->
                <div class="buy_div"
                     v-if="showTabs=='0'">
                  <div class="padding20">
                    <div class="flex_bwn">
                      <div class="flex_dis">
                        <img :src="item.cardInfoData.headPortrait"
                             v-if="item.cardInfoData.headPortrait"
                             class="buy_img" />
                        <img src="@assets/img/empty.png"
                             v-else
                             class="buy_img" />
                        <div class='marLeft10'>
                          <div>{{item.cardInfoData.linkMan}} <span class="font_12">{{item.cardInfoData.title}}</span></div>
                          <div class="marTop">{{item.cardInfoData.companyName}}</div>
                        </div>
                      </div>
                      <div>
                        {{item.inTime | moment("YYYY/MM/DD")}}
                      </div>
                    </div>
                    <div class="marTop"><span class="buy_text_com">{{item.talkType}}</span></div>
                    <div class="buy_many_text"
                         style="height: 85px;">
                      <Tooltip placement="top">
                        <div class="buy_many_text">
                          {{item.talkContent}}
                        </div>
                        <div slot="content"
                             style="white-space: normal;">
                          <p>{{item.talkContent}}</p>
                        </div>
                      </Tooltip>

                    </div>
                  </div>
                  <div
                       style="border-bottom: #e5e5e5 1px solid;">
                  </div>
                  <!-- <div class="marTop padding20_lai"
                       style="border-bottom: #e5e5e5 1px solid;">
                    来源：{{item.sourceName}}
                  </div> -->
                  <div class="flex_bwn">
                    <div></div>
                    <div style=" padding: 10px 20px 10px 10px;">
                      <Poptip confirm
                              title="不发送联系人信息将无法获取观众信息？"
                              @on-ok="ignore(item)"
                              placement="left">
                        <Button type="warning"
                                shape="circle">忽略</Button>
                        <!-- <span class="lookClass"
                      @click="handleP(row,'1')">再次通知</span> -->
                      </Poptip>

                      <Button type="info"
                              class='marLeft10'
                              @click="handleAgree(item)"
                              shape="circle">同意</Button>
                    </div>
                  </div>
                </div>
                <!-- 已接收 -->
                <div class="buy_div"
                     
                     v-if="showTabs=='1'">
                  <div class="padding20">
                    <div class="flex_bwn">
                      <div class="flex_dis">
                        <img :src="item.cardInfoData.headPortrait"
                             v-if="item.cardInfoData.headPortrait"
                             class="buy_img" />
                        <img src="@assets/img/empty.png"
                             v-else
                             class="buy_img" />
                        <div class='marLeft10'>
                          <div>{{item.cardInfoData.linkMan}} <span class="font_12">{{item.cardInfoData.title}}</span></div>
                          <div v-if="item.phoneShow"
                               class="marTop">手机：{{item.cardInfoData.mob | filterTel}} <span class="lookClass"
                                  @click="lookPhone(index)">查看</span></div>
                          <div class="marTop"
                               @click="lookPhoneUn(index)"
                               v-else>手机：{{item.cardInfoData.mob }} <span class="lookClass">隐藏</span></div>
                        </div>
                      </div>
                      <div class="lookClass">

                      </div>
                    </div>
                    <div style="padding:10px 0"><span class="">{{item.cardInfoData.companyName}}</span></div>
                    <div class="">
                      <div style="display:flex">
                        <div class="buy_text_com_blue">{{item.talkType}}</div>
                        <div class="buy_many_text_one marLeft10">
                          <Tooltip placement="top">
                            <div class="buy_many_text_one">
                              {{item.talkContent}}
                            </div>
                            <div slot="content"
                                 style="white-space: normal;">
                              <p>{{item.talkContent}}</p>
                            </div>
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="marTop padding20_lai"
                       style="border-bottom: #e5e5e5 1px solid;">
                    对接人：{{item.receiverCardInfo?item.receiverCardInfo.linkMan:"无"}}
                    <span style="font-size: 12px;">{{item.receiverCardInfo?item.receiverCardInfo.title:"无"}}</span>
                  </div>
                  <div class="flex_bwn">
                    <div></div>
                    <div style=" padding: 10px 20px 10px 10px;">
                      <Poptip confirm
                              title="您确定要删除吗？"
                              @on-ok="handelDelete(item)"
                              placement="left">
                        <Button type="primary"
                                shape="circle">删除</Button>
                        <!-- <Button type="warning"
                                shape="circle">忽略</Button> -->
                      </Poptip>

                    </div>
                  </div>
                </div>

              </div>
              </Col>
            </Row>
          </div>
          <div class="u-empty"
               v-else>暂无数据</div>

          <div class="my-page"
               v-if="totalCount > pageSize">
            <Page show-total
                  show-elevator
                  :page-size="pageSize"
                  :current="pageIndex"
                  :total="totalCount"
                  @on-change="changePage"
                  @on-page-size-change="changePageSize" />
          </div>
        </template>
      </div>
    </div>

    <iModal title="指派联络员："
            v-model="selectModel"
            class-name="vertical-center-modal"
            width="600px"
            :mask-closable="false">
      <div style="padding:30px">
        <Select v-model="contactsId"
                filterable>
          <Option v-for="(item,index) in contactsList"
                  :value="item.id"
                  :key="index">{{ item.linkMan }}</Option>
        </Select>
      </div>

      <div class="addInfo">
        <div></div>
        <Button @click="addUserInfo">添加联络人</Button>
      </div>

      <div slot="footer">
        <Button type="primary"
                @click="handleSubmitContacts()">确定</Button>
        <Button @click="selectModel=false">取消</Button>

      </div>
    </iModal>

    <iModal title="添加人员信息："
            v-model="infoModal"
            class-name="vertical-center-modal"
            width="600px"
            :mask-closable="false">
      <Form ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="100"
            @submit.native.prevent>

        <FormItem label="姓名："
                  prop="LinkMan">
          <Input type="text"
                 v-model="formInline.LinkMan"
                 placeholder="请输入..." />
        </FormItem>
        <FormItem label="手机号："
                  prop="Mob">
          <Input type="text"
                 v-model="formInline.Mob"
                 placeholder="请输入..." />
        </FormItem>
        <FormItem label="职务："
                  prop="Title">
          <Input type="text"
                 v-model="formInline.Title"
                 placeholder="请输入..." />
        </FormItem>
        <FormItem label="邮箱："
                  prop="Email">
          <Input type="text"
                 v-model="formInline.Email"
                 placeholder="请输入..." />
        </FormItem>
      </Form>

      <div slot="footer">
        <Button type="primary"
                @click="handleSubmitUserInfo('formInline')">确定</Button>
        <Button @click="infoModal=false">取消</Button>
      </div>
    </iModal>

    <div class="catalogue-content"></div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
// import exhibitionCarYes from "./components/exhibition-car-yes";
// import exhibitionCarNo from "./components/exhibition-car-no";

export default {
  name: 'exhibition-info-carApply',
  filters: {
    //加密手机号
    filterTel(val) {
      if (val) {
        return val.substring(4, 0) + '****' + val.substring(8)
      }
    },
  },
  data() {
    return {
      infoModal: false,
      formInline: {
        LinkMan: '',
        Mob: '',
        Title: '',
        Email: '',
      },
      ruleInline: {
        LinkMan: [{ required: true, message: '姓名不能为空', trigger: 'blur' }],
        Mob: [{ required: true, message: '手机号不能为空', trigger: 'blur' }],
        Title: [{ required: true, message: '职务不能为空', trigger: 'blur' }],
        Email: [{ required: true, message: '邮箱不能为空', trigger: 'blur' }],
      },
      contactsList: [],
      contactsId: '',

      con: '',
      modalDetail: false,
      editBrand: false,
      editBrandnfo: null,
      editTopic: false,
      editTopicnfo: null,
      search: '',
      editInfo: null,
      pageSize: 20,
      pageIndex: 1,
      totalCount: 0,

      list: [],
      selection: [], // 选中项目
      addShow: false,
      phoneShow: true,
      selectModel: false,
      agreeUserInfo: {},
      showTabs: '0',
      PoptipTitle: '',
    }
  },
  components: {
    // exhibitionCarYes,
    // exhibitionCarNo
  },
  computed: {
    ...mapGetters({
      company: 'loginModule/getCompany',
      exhibition: 'loginModule/getExhibition',
      exhibitionInfo: 'hostSetModule/getHostExhibition',
    }),
  },
  created() {
    document.title = '国际焙烤展 - 采买资讯'
    this.init()
    this.getConUser()
  },
  methods: {
    switchBrand(name) {
      this.init()
    },
    lookPhone(index) {
      this.list[index].phoneShow = false
    },
    lookPhoneUn(index) {
      this.list[index].phoneShow = true
    },

    ...mapActions({
      getExhibitionBuyConsult: 'exhibitionModule/getExhibitionBuyConsult',
      getExhibitionBuyExport: 'exhibitionModule/getExhibitionBuyExport',
      putExhibitionUpdateState: 'exhibitionModule/putExhibitionUpdateState',
      getContactsList: 'exhibitionModule/getContactsList',
      getExhibitionAddUser: 'exhibitionModule/getExhibitionAddUser',
      delReceived: 'exhibitionModule/delReceived',
    }),
    // 获取联系人列表
    async getConUser() {
      let proDataList = await this.getContactsList(this.company.id)
      if (proDataList) {
        this.contactsList = proDataList
      }
    },
    async init() {
      if (this.showTabs == '0') {
        this.hour24 = true
        this.stateInit = '0'
      }
      if (this.showTabs == '1') {
        this.hour24 = true
        this.stateInit = '1'
      }

      this.option = {
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
        hour24: this.hour24,
        conditions: {
          compid: this.company.id,
          state: this.stateInit,
        },
      }

      let proData = await this.getExhibitionBuyConsult(this.option)
      if (proData) {
        proData.items.map((c) => {
          c.phoneShow = true
          if (c.categories) {
            c.categories = JSON.parse(c.categories)
          } else {
            c.categories = []
          }
          if (c.boothInfo) {
            c.boothInfo = JSON.parse(c.boothInfo)
          } else {
            c.boothInfo = []
          }
        })
        this.list = proData.items
        this.pageSize = proData.pageSize
        this.pageIndex = proData.pageIndex
        this.totalCount = proData.totalCount
      }
    },
    async setAudit(row) {
      console.log(row)
      const opt = {
        joinIds: [row.joinId],
      }
      const bool = await this.setOneStepAudit(opt)
      if (bool && bool.successed) {
        this.$Message.success('操作成功')
        this.init()
      } else {
        this.$Message.error('操作失败，请重新尝试')
      }
    },
    async setAllAudit() {
      const reqList = []
      if (!this.selection.length) return
      this.selection.forEach((c) => {
        reqList.push(c.joinId)
      })
      const bool = await this.setOneStepAudit({
        joinIds: reqList,
      })
      if (bool && bool.successed) {
        this.$Message.success('操作成功')
        this.init()
      } else {
        this.$Message.error('操作失败，请重新尝试')
      }
    },
    changePage(e) {
      this.pageIndex = e
      this.init()
    },
    changePageSize(e) {
      this.pageSize = e
      this.init()
    },
    edit(item) {
      this.editInfo = item
    },
    searchPro() {
      this.pageIndex = 1
      this.init()
    },
    changeEvent(selection) {
      this.selection = selection
    },

    handleP(row, index) {
      if (this.showTabs == '1') {
        this.PoptipTitle = '是否已经处理完毕？'
      }
      if (this.showTabs == '2') {
        this.PoptipTitle = '确定要再次通知吗？'
      }
      if (this.showTabs == '4') {
        this.PoptipTitle = '您确定要激活吗？'
      }
    },
    rejectP(row, index) {
      this.PoptipTitle = '确定驳回吗？'
    },
    // 展商导出
    async hostExcelExportBack() {
      if (this.showTabs == '0') {
        let opt = {
          pageSize: 500000,
          pageIndex: 1,
          hour24: true,
          conditions: {
            compid: this.company.id,
            state: '0',
          },
        }
        let data = await this.getExhibitionBuyExport(opt)
      }
      if (this.showTabs == '1') {
        let opt = {
          pageSize: 500000,
          pageIndex: 1,
          hour24: true,
          conditions: {
            compid: this.company.id,
            state: '1',
          },
        }
        let data = await this.getExhibitionBuyExport(opt)
      }
    },
    // 忽略
    async ignore(row) {
      console.log(row)
      const opt = {
        id: row.id,
        setValues: {
          State: 2,
        },
      }
      const bool = await this.putExhibitionUpdateState(opt)
      if (bool && bool.successed) {
        this.$Message.success('操作成功')
        this.init()
      } else {
        this.$Message.error('操作失败，请重新尝试')
      }
    },
    handleAgree(row) {
      this.agreeUserInfo = row
      this.selectModel = true
    },
    addUserInfo() {
      this.infoModal = true
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          resolve(valid)
        })
      })
    },
    async handleSubmitUserInfo(name) {
      let valid = await this.validForm(name)
      if (!valid) return
      let opt = {
        linkMan: this.formInline.LinkMan,
        title: this.formInline.Title,
        linkMob: this.formInline.Mob,
        linkEMail: this.formInline.Email,
        cusmer: this.company.clientId,
      }
      let add = await this.getExhibitionAddUser(opt)
      if (add && add.successed) {
        this.infoModal = false
        this.getConUser()
        this.$Message.success('操作成功')
      } else {
        this.$Message.error('操作失败，请重新尝试')
      }
    },
    async handleSubmitContacts() {
      let data = {}
      this.contactsList.map((e) => {
        if (this.contactsId == e.id) {
          data.linkEMail = e.linkEMail
          data.linkMan = e.linkMan
          data.linkMob = e.linkMob
          data.title = e.title
        }
      })

      let opt = {
        Id: this.agreeUserInfo.id,
        setValues: {
          State: 1,
          ReceiverCardInfo: {
            CompanyName: this.company.name,
            HeadPortrait: '',
            LinkMan: data.linkMan,
            Mob: data.linkMob,
            Title: data.title,
            Email: data.linkEMai,
          },
        },
      }
      const bool = await this.putExhibitionUpdateState(opt)
      if (bool && bool.successed) {
        this.selectModel = false
        this.$Message.success('采购信息已发送至对接人手机和邮箱')
        this.init()
      } else {
        this.$Message.error('操作失败，请重新尝试')
      }
    },

    // 删除 已接收
   async handelDelete(row){
         const bool = await this.delReceived(row.id)
      if (bool && bool.successed) {
        this.$Message.success('操作成功')
        this.init()
      } else {
        this.$Message.error('操作失败，请重新尝试')
      }

    },
  },
}
</script>

<style scoped lang="scss">
.catalogue {
  .header-tool {
    min-height: 90px;
  }
  &-content {
    min-width: 1000px;
    margin: 24px;
    padding: 40px;
    min-height: 500px;
    padding-bottom: 190px;
  }
}
.cib {
  min-width: 1000px;
  margin: 30px;
  padding: 40px;
  min-height: 500px;
  background: #fff;
  padding-bottom: 190px;
}
.spanClass {
  margin-left: 4px;
  margin-right: 4px;
}

.deleteClass {
  color: #f78989;
  // cursor:pointer;
}
.lookClass {
  color: #1890ff;
  cursor: pointer;
}

// 采买资讯
.buy_div {
  border-right: #e5e5e5 1px solid;
  border-bottom: #e5e5e5 1px solid;
}
.padding20 {
  padding: 20px 20px 0px 20px;
}
.padding20_lai {
  padding: 0 0 10px 20px;
}
.buy_img {
  width: 60px;
  height: 60px;
  border-radius: 50px;
  border: #f78989 1px solid;
}
.flex_bwn {
  display: flex;
  justify-content: space-between;
}
.flex_dis {
  display: flex;
}
.font_12 {
  font-size: 12px;
}
.buy_text_com {
  border: #e6662e 1px solid;
  color: #e6662e;
}
.buy_text_com_blue {
  //   border: #1890ff 1px solid;
  width: 40px;
  height: 20px;
  display: block;
  text-align: center;
  border-radius: 3px;
  background: #1890ff;
  color: #fff;
}
.buy_many_text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}
.buy_many_text_one {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.marTop {
  margin-top: 10px;
}
.marLeft10 {
  margin-left: 10px;
}
.my-page {
  text-align: center;
}
.addInfo {
  display: flex;
  justify-content: end;
  margin-right: 30px;
}
</style>
